import { render } from "./OtherSubComponents.vue?vue&type=template&id=4429951c"
import script from "./OtherSubComponents.vue?vue&type=script&lang=js"
export * from "./OtherSubComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__